export const EVC_LISTINGS_LIMIT = 10;

export const SORTING_ORDERS = {
    ASC: "asc",
    DESC: "desc"
}

export const NOT_ALLOWED_TO_UPDATE_SITES = ["Technician"]

export const STAGE_ENABLED_REGISTERS = [40129, 40147, 40165, 40183, 40203, 40221, 40303, 40321, 40339, 40357];
